import React, { useState } from 'react';

import style from './select.module.css';
import bottomin from '../../img/bottom_in.svg';

const CustomSelect = ({options,selected,setTarget}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (option) => {
    setTarget(option);
    setIsOpen(false);
  };

  return (
    <div className={style.customSelect}>
      <div className={style.selected} onClick={() => setIsOpen(!isOpen)}>
        {selected ? selected : 'Нажмите для выбора'}
        <img src={bottomin} className={isOpen ? style.transselect : null} alt=''/>
      </div>
      {isOpen && (
        <div className={style.options}>
          {options.map((option) => (
            (option === selected ? null
            :
            <div key={option} className={style.option} onClick={() => handleSelect(option)}>
              {option}
            </div>
            )
          ))}
        </div>
      )}
    </div>
  );
};
export default CustomSelect;